import toast, { ToastOptions } from 'react-hot-toast';

export type CustomToastOptions = ToastOptions & {
  type: 'success' | 'error';
};

const popToast = (
  msg: string,
  options: CustomToastOptions = { type: 'success' },
) => {
  const { type } = options;

  if (type === 'success') toast.success(msg);

  if (type === 'error') toast.error(msg);
};

export { popToast };
